<img alt="" src="assets/images/svgs/magic.svg" />
